// =============================================
// frontend/src/index.js
// =============================================
// Ye application ka entry point hai.
// Yahan authentication-aware routing hoti hai:
//   - /admin    → AdminPage (admin dashboard)
//   - /         → Agar authenticated hain → App (Screenshot Studio)
//   - /         → Agar nahi hain + token hai → LoginPage
//   - /         → Agar nahi hain + token nahi → Access restricted
//
// App.js ko bilkul nahi chheda — sirf wrap kiya hai.

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AdminPage from './pages/AdminPage';
import LoginPage from './pages/LoginPage';
import useAuth from './hooks/useAuth';
import reportWebVitals from './reportWebVitals';

// -------------------------------------------
// Root Component — Auth-aware routing
// Ye decide karta hai konsa page render hoga
// -------------------------------------------
function Root() {
  const { user, loading } = useAuth();

  // URL se path aur query params nikaalte hain
  const path = window.location.pathname;
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');
  const error = params.get('error');

  // /admin path pe AdminPage dikhao — no auth check (AdminPage apna karta hai)
  if (path === '/admin' || path === '/admin/') {
    return <AdminPage />;
  }

  // Auth check load ho rahi hai — loading spinner dikhao
  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#0f172a',
        color: 'rgba(255,255,255,0.5)',
        fontFamily: 'system-ui, sans-serif',
        fontSize: '0.9rem',
        gap: '0.75rem',
      }}>
        <div style={{
          width: 20, height: 20,
          border: '2px solid rgba(255,255,255,0.2)',
          borderTop: '2px solid #3b82f6',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }} />
        Loading…
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  // Authenticated hai → Screenshot Studio dikhao
  if (user) {
    return <App />;
  }

  // Authenticated nahi hai → Login page dikhao (token ya error ke saath)
  return <LoginPage token={token} error={error} />;
}

// -------------------------------------------
// App render karo
// -------------------------------------------
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

